import PortfolioInfoContainer from "./PortfolioInfoContainer";
import PortfolioInfoStore from "./PortfolioInfoStore";

export default PortfolioInfoStore(PortfolioInfoContainer);